export default class RefreshEmbedTokensConversations {
  constructor(context) {
    this.context = context;
  }

  run({ apiToken, navigationToken }) {
    this.context.stores.embedTokensConversations.setLoading();
    this.context.gateways.embedTokensConversationsRefresh.add({ apiToken, navigationToken });
  }
}
